var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.productData.title)+"\n  "),(_vm.productData.is_delete === 1)?_c('q-chip',{attrs:{"color":"red","text-color":"white","label":"(停用)"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }